/**
 * Reads the payload of a JWT on the client. No signature verification — the backend
 * still authorizes every request; this is only used to decide what UI to show.
 */
export const decodeJwtPayload = (token: string | null): Record<string, unknown> | null => {
  const payload = token?.replace(/^Bearer\s+/i, '').split('.')[1]
  if (!payload) return null
  try {
    // JWT segments are base64url-encoded; atob only understands standard base64.
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
  } catch {
    return null
  }
}
